import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { scroll } from "../../../../components/utils/utils";
import { Row } from "antd";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import StudentsCollapse from "./StudentsCollapse";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
// import AddRegistrationRequest from "./AddRegistrationRequest";

import CustomConfigProvider from "../../ProfileHeader";
import { getSchoolProfileDetails } from "../../../../apis/actions/school.actions";
const StudentsPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { data: schoolProfileDetails, loading } = useSelector(
    (state: RootState) => state?.school?.schoolProfileDetails
  );

  useEffect(() => {
    dispatch(getSchoolProfileDetails());
  }, [dispatch]);

  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <CustomConfigProvider
        title="قائمة الطلاب"
        withdateFilter={false}
      ></CustomConfigProvider>

      <Row
        justify={"space-between"}
        className="takaful--request-col-space"
        style={{ marginBottom: "1rem" }}
      >
  
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : schoolProfileDetails?.student_idslength === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      )  : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <StudentsCollapse
              students={schoolProfileDetails?.student_ids.slice(
                (currentPage - 1) * itemPerPage,
                (currentPage - 1) * itemPerPage + itemPerPage
              )}
            />
          </Row>
          <div className="takaful--pagination-container">
            {schoolProfileDetails?.student_ids &&
              schoolProfileDetails?.student_ids?.length >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={schoolProfileDetails?.student_ids?.length}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
      {/*
      <AddRegistrationRequest
        beneficiary={filterOrphans}
        universities={universities}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
      />
      */}
    </>
  );
};

export default StudentsPage;
